<div class="modal-overlay" *ngIf="showModal">
	<viewport-container>
		<div #theModal class="modal" [ngStyle]="parameterizedStyles">
			<ng-content></ng-content>
		</div>
	</viewport-container>
</div>
